<div class="user-form-container">
    @if (!isExternal) {
    <div class="select-box">
        <mat-form-field>
            <mat-label>Propriétés</mat-label>
            <input #propertyInput type="text" matInput [matAutocomplete]="auto" [formControl]="propertyListControl"
                (focusin)="propertyListControl.setValue('')" />
            <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" hideSingleSelectionIndicator="true">
                @for (property of propertyList | async; track property) {
                <mat-option [value]="property.name">
                    <mat-checkbox class="accent-button" (click)="$event.stopPropagation()"
                        (change)="toggleSelection(property)" [checked]="property.isSelected">
                        {{ property.display }}
                    </mat-checkbox>
                </mat-option>
                }
            </mat-autocomplete>
        </mat-form-field>
        <button [disabled]="selectedProperties.length <= 0 || selectedProperties.includes('customProperty')"
            mat-icon-button type="button" class="accent-button" matTooltip="{{ 'Property.AddProperty'}}"
            (click)="addProperty(selectedProperties)">
            <mat-icon>add_circle</mat-icon>
        </button>
    </div>
    }

    <div class="properties-box" [formGroup]="propertiesForm">
        @if (propertiesForm !== undefined) {
        <div formArrayName="propertiesGroup">
            <mat-form-field>
                <mat-label>Filtre des propriétés</mat-label>
                <input autocomplete="off" class="primary-button" placeholder="{{ 'Property.FilterLabel'}}"
                    class="search-input" #search matInput type="text" [(ngModel)]="searchProperty"
                    [ngModelOptions]="{ standalone: true }" />
                @if (search.value.length > 0) {
                <button matSuffix mat-icon-button class="primary-button" (click)="resetSearch()">
                    <mat-icon>close</mat-icon>
                </button>
                }
                @if (search.value.length < 1) { <mat-icon class="primary-button" matSuffix>search</mat-icon>
                    }
            </mat-form-field>
            @for (property of propertiesControls | formArrayFilterPipe: searchProperty; track property; let i = $index)
            {
            {{ getPropertyTranslate($safeNavigationMigration(property.get('name')?.value)) }}
            <div class="property">
                <div class="property-container" [formGroupName]="i">
                    <div class="property-type">
                        @if (property.value.type === 'Number') {
                        <mat-form-field>
                            <mat-label>{{ getPropertyTranslate(property['controls'].name.value) }}</mat-label>
                            <input matInput type="number" (input)="onChanges()" formControlName="value" />
                        </mat-form-field>
                        }
                    </div>
                    <div class="property-type">
                        @if (property.value.type === 'Text') {
                        <mat-form-field>
                            <mat-label>{{ getPropertyTranslate(property['controls'].name.value) }}</mat-label>
                            <input matInput type="text" (input)="onChanges()" [errorStateMatcher]="matcher"
                                formControlName="value" />
                        </mat-form-field>
                        }
                    </div>
                    <div class="property-type">
                        @if (property.value.type === 'List' || property.value.type === 'MList') {
                        <mat-form-field>
                            <mat-label>{{ getPropertyTranslate(property['controls'].name.value) }}</mat-label>
                            <mat-select formControlName="value" [multiple]="property.value.type === 'MList'"
                                (selectionChange)="onChanges()">
                                @for (listValue of property.value.values; track listValue) {
                                <mat-option [value]="listValue">
                                    {{ listValue }}
                                </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                        }
                    </div>
                    <div class="property-type">
                        @if (property.value.type === 'Date') {
                        <mat-form-field>
                            <mat-label>{{ getPropertyTranslate(property['controls'].name.value) }}</mat-label>
                            <input matInput [matDatepicker]="datepicker" (dateChange)="onChanges()"
                                formControlName="value" />
                            <mat-datepicker-toggle class="accent-button" matSuffix
                                [for]="datepicker"></mat-datepicker-toggle>
                            <mat-datepicker #datepicker disabled="false"></mat-datepicker>
                        </mat-form-field>
                        }
                    </div>
                    <div class="property-type">
                        @if (property.value.type === 'Datetime') {

                        <mat-form-field>
                            <mat-label>{{ getPropertyTranslate(property['controls'].name.value) }}</mat-label>
                            <input matInput [ngxMatDatetimePicker]="datetimepicker" (dateChange)="onChanges()"
                                formControlName="value" />
                            <ngx-mat-datepicker-toggle matSuffix class="accent-button"
                                [for]="datetimepicker"></ngx-mat-datepicker-toggle>
                            <ngx-mat-datetime-picker #datetimepicker></ngx-mat-datetime-picker>
                        </mat-form-field>

                        }
                    </div>
                    <div class="property-type">
                        @if (property.value.type === 'Time') {
                        <mat-form-field>
                            <mat-label>{{ getPropertyTranslate(property['controls'].name.value) }}</mat-label>
                            <input matInput type="time" (change)="onChanges()" formControlName="value" />
                        </mat-form-field>
                        }
                    </div>
                    @if (property.value.type === 'Check') {
                    <div class="property-type">
                        <mat-checkbox class="accent-button" formControlName="value" (change)="onChanges()">
                            {{ getPropertyTranslate(property['controls'].name.value) }}
                        </mat-checkbox>
                    </div>
                    }
                    <div class="property-type">
                        @if (property.value.type === 'Range') {
                        <mat-form-field>
                            <span matPrefix>[{{ property.value.values[0] }}]&nbsp;&nbsp;</span>
                            <input matInput type="number"
                                placeholder="{{ getPropertyTranslate(property['controls'].name.value) }}"
                                (input)="onChanges()" [min]="property.value.values[0]" [max]="property.value.values[1]"
                                formControlName="value" />
                            <span matSuffix>&nbsp;&nbsp;[{{ property.value.values[1] }}]</span>
                        </mat-form-field>
                        }
                    </div>
                    <div>
                        @if (!isExternal) {
                        <mat-form-field>
                            <mat-label>Champ d'application</mat-label>
                            <input matInput [value]="getScopeLabel(property['controls'].scope.value)" disabled
                                readonly />
                        </mat-form-field>
                        }
                    </div>
                    <div class="property-readonly">
                        @if (!isExternal) {
                        <mat-checkbox class="primary-button" formControlName="readonly">En lecture seule</mat-checkbox>
                        }
                    </div>
                    <div class="property-legacyable">
                        @if (!isProfile && !isExternal) {
                        <mat-checkbox class="primary-button" formControlName="legacyable">Héritable</mat-checkbox>
                        }
                    </div>
                    <div class="property-legacy">
                        @if (!isExternal) {
                        <mat-checkbox class="primary-button" formControlName="legacy">Hérité</mat-checkbox>
                        }
                    </div>
                    @if (!isExternal) {
                    <button mat-icon-button type="button" matTooltip="Supprimer la propriété"
                        [disabled]="isProfile && property['controls'].scope.value === managedScope"
                        (click)="deleteProperty(property.value.name, i)" class="primary-button">
                        <mat-icon>disabled_by_default</mat-icon>
                    </button>
                    }
                </div>
            </div>
            }
        </div>
        }
    </div>
</div>

<ngx-spinner name="spinner" bdColor="rgba(0, 0, 0, 0.2)" size="medium" color="#00D2B4" type="timer"
    [fullScreen]="false"></ngx-spinner>